import {CSSProperties, ReactNode} from 'react'
import {jsclj, resolveGoogExport} from 'dgetz/tsclj'

interface TextProps {
  children: ReactNode;

  size?: string;
  weight?: string;
  lineHeight?: string;
  fontSize?: string;
  color?: string;
  tag?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'footer';
  desktopSize?: string;
  mobileSize?: string;
  textAlign?: string;
  style?: CSSProperties;
  className?: string;
  block?: boolean;
}

export function Text(props : TextProps) {
  const text = resolveGoogExport('ladder.ux.typography.text')
  return text(jsclj({
    'block?': props.block,
    class: props.className,
    color: props.color,
    'desktop-size': props.desktopSize,
    'font-size': props.fontSize,
    'line-height': props.lineHeight,
    'text-align': props.textAlign,
    'mobile-size': props.mobileSize,
    size: props.size,
    style: props.style,
    tag: props.tag,
    weight: props.weight,
  }), props.children)
}
